import { Group } from '@components/layout';
import { Stack, useMediaQuery, useTheme } from '@mui/material';
import { ReactNode } from 'react';

type RegistrationPageLayoutProps = {
  content: ReactNode;
  form: ReactNode;
};

export const RegistrationPageLayout = ({ content, form }: RegistrationPageLayoutProps) => {
  const { breakpoints, palette } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('md'));

  if (isMobile) {
    return (
      <Stack sx={{ backgroundColor: palette.background.default }}>
        <Stack
          flex={1}
          alignItems="center"
          justifyContent="center"
          sx={{
            backgroundColor: palette.background.paper,
            borderRight: `1px solid ${palette.divider}`,
          }}
        >
          {content}
        </Stack>
        <Stack flex={1} alignItems="center" justifyContent="center">
          {form}
        </Stack>
      </Stack>
    );
  }

  return (
    <Group sx={{ minHeight: '100vh', backgroundColor: palette.background.default }}>
      <Stack
        flex={2}
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundColor: palette.background.paper,
          borderRight: `1px solid ${palette.divider}`,
        }}
      >
        {content}
      </Stack>
      <Stack flex={3} alignItems="center" justifyContent="center">
        {form}
      </Stack>
    </Group>
  );
};
